import { useEffect, useRef, useState, useSyncExternalStore } from 'react';

import { phone, type PhoneState } from './phone/store';

export const usePhone = (): PhoneState => useSyncExternalStore(phone.subscribe, phone.getState);

// Reloj que se actualiza cada N ms (para cronometros), solo mientras se usa.
export function useNow(ms = 1000, activo = true) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!activo) return;
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms, activo]);
  return now;
}

export function useDebounced<T>(valor: T, ms = 200) {
  const [v, setV] = useState(valor);
  useEffect(() => {
    const t = setTimeout(() => setV(valor), ms);
    return () => clearTimeout(t);
  }, [valor, ms]);
  return v;
}

// Celular (D100): el mismo corte de 900 px que usa la hoja de estilos (styles/movil.css). Cambia sola al girar el
// telefono o al cambiar el tamano de la ventana.
export const CORTE_MOVIL = '(max-width: 900px)';
const consultaMovil = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(CORTE_MOVIL) : null;
export const esMovil = () => !!consultaMovil?.matches;
export const useMovil = () =>
  useSyncExternalStore(
    (f) => (consultaMovil?.addEventListener('change', f), () => consultaMovil?.removeEventListener('change', f)),
    esMovil,
  );

// true si el foco esta en un campo de texto (para no disparar atajos al escribir).
export const escribiendo = (e: KeyboardEvent) => {
  const t = e.target as HTMLElement | null;
  if (!t) return false;
  const tag = t.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || t.isContentEditable;
};

export function useKey(handler: (e: KeyboardEvent) => void) {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    const fn = (e: KeyboardEvent) => ref.current(e);
    window.addEventListener('keydown', fn);
    return () => window.removeEventListener('keydown', fn);
  }, []);
}
